import { render, staticRenderFns } from "./GameBoardHUD.vue?vue&type=template&id=35f88579&scoped=true&"
import script from "./GameBoardHUD.vue?vue&type=script&lang=js&"
export * from "./GameBoardHUD.vue?vue&type=script&lang=js&"
import style0 from "./GameBoardHUD.vue?vue&type=style&index=0&id=35f88579&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f88579",
  null
  
)

export default component.exports